import React from 'react';

const TextPreview = ({ content, filename }) => {
  const getLanguage = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    const langMap = {
      js: 'javascript', jsx: 'javascript', ts: 'typescript', tsx: 'typescript',
      css: 'css', html: 'html', xml: 'xml', json: 'json',
      py: 'python', java: 'java', cpp: 'cpp', c: 'c'
    };
    return langMap[ext] || 'text';
  };

  const language = getLanguage(filename);
  const isCode = !['txt', 'md'].includes(filename.split('.').pop().toLowerCase());

  return (
    <div className="bg-white rounded-lg overflow-hidden min-h-96">
      <div className="bg-gray-50 p-4 border-b flex justify-between items-center">
        <p className="text-sm text-gray-600">
          {isCode ? `Code Preview (${language})` : 'Text Preview'}
        </p>
        <p className="text-xs text-gray-500">
          {content.split('\n').length} lines
        </p>
      </div>
      <div className="p-4 overflow-auto max-h-96">
        <pre className={`text-sm text-gray-900 whitespace-pre-wrap overflow-auto ${
          isCode ? 'font-mono bg-gray-50 p-4 rounded' : ''
        }`}>
          {content}
        </pre>
      </div>
    </div>
  );
};

export default TextPreview;